var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 896",
    width: 800,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,225)",
    d: "m0 0h16l4 1 1 4v12l-4 10-12 21-8 17-9 23-9 32-4 23-2 18v34l3 26 5 23 10 30 11 26 14 27 10 15 14 19 8 10 9 10 17 17 14 11 16 12 18 11 19 11 4 2h11l7-7 7-8 10-11 13-17 10-15 6-15 9-34 5-15 3-15 2-17 2-12 2-20 3-12 9-20 7-21 7-9 12-6 18-3 13-6 10-2h27l13 4 11 7 6 8 5 16 1 28v20l-3 7-9 19-3 3-6 1h-21l-8 11 3 3 16 10 10 12 8 10 11 9 5-1 18-14 13-11 10-9 9-9 7-5 3-1-4-1v-15l-1-7-6-6v-18l2-4 13-5 8-10 3-2h16l5 4 4 6 6 4 7 2 4 5v18l-8 7v11l5 2v9l3 1 1 3v19l-4 5-6 3-4 1-22 1-9 6-9 9-9 11-15 16-21 21-9 5h-22l-12-6-15-8-3-1v2l-6 3-3 16 38 1 18 2 18 4 8 4 4 5 2 4v6l11-8 6-4h20l1 1v20l-7 12-11 13-11 12-15 15h-2l2 14 8 27 10 25 5 17 2 10 1 10 1 26 3 13 1 10v11l-2 4-11 2h-11l-10-2-6-4-5-8-6-17-6-11-1-4v-23l3-5 1-6-6-16-8-16-7-12-5-8-14 8-25 12-13 4h-6l-2 5-13 17-18 18-20 13-19 11-12 11-8 9-3 1h-18l-5-2-4-6-1-4v-31l4-7 11-12 2-1-40-2-28-4-30-7-30-10-26-12-18-10-15-10-19-14-10-9-8-7-24-24-11-14-13-18-11-19-8-16-10-23-9-27-7-29-4-22-3-31v-20l2-30 6-31 8-30 10-27 12-25 11-20 10-15 9-12 9-11 12-13 12-12 11-9 12-10zm228 428m-1 1m-1 1-11 12-16 16-6 4 2 2 27 6 2-1v-22l2-13 1-4z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(896,176)",
    d: "m0 0h9l16 4 16 7 14 9 7 6h2l7-8 12-5h17l10 3 11 8 5 7v8l-5 20-1 9v10l1 4 11-16 9-11 9-10 6-7 11-9 10-8 16-9 17-6 5-1h23l13 5 13 9 13 13 4 6v9l-3 20-6 21-10 21-8 11-9 11-11 9-8 6-13 8-16 9-24 11v12l1 3h8l10-4 12-7 11-9 7-7 8-7 11-12 3-2h7l6 4 10 9 2 1 2-14 6-20 10-23 11-19 12-17 14-17 16-16 16-11 11-5 12-3h14l10 5 7 6 8 7 3 4 3-1h7l2 1 12 2 13 5 10 7 8 9v13l-14 31-10 27-8 27-2 9-1 12v17l2 5 11 10 2 3v8l-5 5-10 6-14 6-7 2h-23l-11-6-5-4-6-9-4-9v-4l-8 7-10 10-10 7-11 6-5 2h-22l-11-6-13-13-8-16-2-5-3-14-1-3-9 10-7 8-5 6-8 7-13 11-15 10-21 10-9 3h-16l-12-3-12-5-11-7-12-10-10-14-5-10-5-17v-27l1-4v-8l-7 3-10-4-12-8-13-12-3-4-6 1-13 13-9 10-10 16-9 21-9 29-7 28-3 6-6 4-8 1-12-3-12-5-11-7-10-9-6-8-1-2v-8l7-30 11-39 12-36 9-26 11-27 7-16 10-16 10-10zm210 86m-1 1m-1 1m-1 1-2 4 3-2zm180 2-13 13-8 10-6 8-8 12-8 15-5 16 1 2 13-17 10-15 12-19 13-23zm-184 2-3 4 1 2 4-5z",
    fill: "#F46663"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,71)",
    d: "m0 0h55l26 5 24 8 20 10 12 8 11 9 10 9 10 11 10 15 8 16 5 14 4 17 1 8v35l-3 21-5 21-9 25-10 21-10 16-10 14-12 14-18 18-11 9-17 12-27 14-16 6-23 6-11 2h-43l-16-3-17-6-17-9-11-8-13-13-10-14-5-10v-9l16-38 13-33 19-49 8-22v-1h-16l-16-7-11-8-9-10-7-14-2-6v-10l6-18 8-15 7-9 11-12 13-11 19-11 15-7 14-5 13-3zm68 55 6 8 1 4-5 10-12 20-15 29-14 28-15 33-14 31-16 38-10 28-2 10 2 2 6 1 26-3 15-4 18-8 16-10 11-10 8-7 8-9 10-13 10-16 8-16 7-19 3-10 3-17 2-13v-28l-2-9-4-14-7-13-11-11-14-8-10-3z",
    fill: "#0989F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(182,235)",
    d: "m0 0h4l-2 6-8 13-11 21-8 19-7 21-7 25-5 29-1 9v50l3 24 3 14 7 24 6 17 10 23 8 16 10 19 8 12 8 10 12 16 12 14 10 10 8 7 15 12 12 9 11 7 10 6 4 4 11 6-4 6-4 2-1 4h2v2l13 3 7 4 5 1h7l9-3 17-1 9 3 25 5 6 3 7 1h59l3 1-1 4-4 5-2 7-5 7h-2l-2 4-10 14-7 9-13 18-5 5-16 2-6 3-11 2h-34l-30-3-31-7-17-5-13-5-11-4-27-13-15-9-16-11-17-13-12-11-10-9-8-8-7-8-9-10-12-17-9-14-9-16-10-21-10-26-4-14-7-28-4-25-1-18v-21l1-20 5-32 8-31 8-22 9-21 11-21 12-19 7-10 11-14 11-12 7-8 8-7 9-8 14-11z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1863,179)",
    d: "m0 0h23l16 4 10 4 10 6 11 10 2 3 6-10 4-4 4-1h12l17 1 20 6 13 7 8 7 2 4-1 7-7 16-12 27-12 29-10 27-12 36-10 28-11 26-12 25-12 21-11 16-10 13-8 10-7 7-7 8-14 13-16 11-17 9-14 5-16 3h-23l-18-4-19-7-16-9-10-8-9-10-3-6v-7l4-9 7-8 7-5 6-1 10 5 11 8 2 1h13l12-3 17-8 12-9 12-11 12-13 13-18 10-16 2-4-2 1h-19l-17-5-15-8-11-9-8-10-5-10-1-4v-19l4-24 8-26 9-24 10-22 11-20 13-20 9-11 9-10 9-8zm66 36m-1 1-9 10-11 16-10 18-14 29-7 16 1 3 14-24 13-24 13-23 11-19z",
    fill: "#0989F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1438,176)",
    d: "m0 0 12 3 13 5 16 9 11 9 7 6 3 4v6 2l9-7 14-8 12-4 6-1h9l4 1 11 2 17 8 11 9 4 4 9-8 14-9 16-7 4-1h25l11 4 9 6 7 8 5 9v9l-10 24-15 33-13 30-9 25-4 13h8l6 2 8 7 5 10 1 3v11l-9 8-14 8-12 5-12 3h-13l-12-3-14-7-10-10-8-16-3-14v-20l1-10-13 18-10 14-13 18-14 19-7 8-2 1h-8l-16-8-10-8-8-10-7-14-1-3v-9l5-25-9 11-9 13-8 12-12 17-7 9-9 10-6 5h-9l-6-4-11-10-7-10-5-10-5-19v-10l5-28 7-25 9-25 8-19 24-48 10-18 7-10zm27 159 1 2z",
    fill: "#0989F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1375,598)",
    d: "m0 0h32l23 3 12 4 8 7 3 8 1 8v27l-3 10-7 6-6 2-13-1-6-3-6-7-7-8-12-5-4-1h-14l-5 3v5l-1 1 8 6 27 15 20 12 13 10 9 9 8 13 4 12 1 6v17l-3 14-8 16-11 12-14 9-16 6-21 3h-14l-23-3-23-5-9-4-5-5-3-8-2-10v9h-2l-1-3-5 5-25 13-16 8-4 1h-10l-8-3-6-5-1-2-10 4-21 7-11 2h-17l-16-4-12-5-11-6-10-8-11-11-9-14-5-14-1-6-1-82-8-6-5-6-2-6v-7l6-9 12-12 17-13 9-6 7-2h12l7 3 6 8 2 7 1 122 3 8 5 5 6 4 10 3 12 1 16-3 14-6 3-1-1-112-6-4-5-6-2-5v-11l3-6 5-5 8-2h42l8 2 5 6 3 8 2 14 1 19 1 105 8 4 4 3 4-11 9-8 9-3h9l7 4 7 7 14 7 14 4 14 1 8-3 1-2v-6l-4-5-18-10-28-15-13-9-15-15-8-13-4-12-1-7v-15l4-16 6-10 9-10 11-7 14-6 13-3zm-70 166 1 2z",
    fill: "#F2332E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,599)",
    d: "m0 0h24l13 4 11 6 9 7 7 7 9 14 5 13 2 9 1 9 1 101 1 5 8 6 4 7v12l-4 8-5 4-6 2h-60l-8-3-5-5-3-7v-8l4-9 7-6 2-1 1-4v-93l-1-12-3-6-6-3h-14l-16 3-8 2 1 108 1 5 6 4 5 6 2 6-1 10-5 8-6 4-5 1h-58l-9-3-6-7-1-3v-13l6-9 6-4 1-2v-102l-2-9-2-3-7-2h-15l-14 3-10 3v85l1 27 8 6 4 6 1 8-2 9-6 7-9 3h-60l-8-3-5-6-2-6v-8l3-7 5-6 6-4 1-106-6-2-5-4-4-8v-13l4-6 10-9 18-13 10-7 10-4h7l9 3 6 5 7-1 18-6 11-2h27l13 4 12 7 9 7 5-2 16-8 16-6z",
    fill: "#0889F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,225)",
    d: "m0 0h16l4 1 1 4v12l-4 10-12 21-8 17-9 23-9 32-4 23-2 18v34l3 26 5 23 10 30 11 26 14 27 10 15 14 19 8 10 9 10 17 17 14 11 16 12 18 11 19 11 4 2h11l7-7 7-8 10-11 13-17 10-15 6-15 9-34 5-15 3-15 2-17 2-12 2-20 3-12 9-20 7-21 7-9 12-6 18-3 13-6 10-2h27l13 4 11 7 6 8 5 16 1 28v20l-3 7-9 19-3 3-6 1h-21l-8 11 3 3 16 10 10 12 8 10 11 9 5-1 18-14 13-11 10-9 9-9 7-5 3-1-4-1v-15l-1-7-6-6v-18l2-4 13-5 8-10 3-2h16l5 4 4 6 6 4 7 2 4 5v18l-8 7v11l5 2v9l3 1 1 3v19l-4 5-6 3-4 1-22 1-9 6-9 9-9 11-15 16-21 21-9 5h-22l-12-6-15-8-3-1v2l-6 3-3 16 38 1 18 2 18 4 8 4 4 5 2 4v6l11-8 6-4h20l1 1v20l-7 12-11 13-11 12-15 15h-2l2 14 8 27 10 25 5 17 2 10 1 10 1 26 3 13 1 10v11l-2 4-11 2h-11l-10-2-6-4-5-8-6-17-6-11-1-4v-23l3-5 1-6-6-16-8-16-7-12-5-8-14 8-25 12-13 4h-6l-2 5-13 17-18 18-20 13-19 11-12 11-8 9-3 1h-18l-5-2-4-6-1-4v-31l4-7 11-12 2-1-40-2-28-4-30-7-30-10-26-12-18-10-15-10-19-14-10-9-8-7-24-24-11-14-13-18-11-19-8-16-10-23-9-27-7-29-4-22-3-31v-20l2-30 6-31 8-30 10-27 12-25 11-20 10-15 9-12 9-11 12-13 12-12 11-9 12-10zm7 10-13 10-13 11-13 12-7 8-12 14-10 14-9 14-9 15-12 25-10 26-5 17-6 26-4 26-1 20v21l1 18 5 30 8 31 8 22 11 25 10 19 10 16 12 16 9 11 7 7 7 8 9 9 8 7 13 11 11 8 16 11 21 12 25 12 15 5 17 6 23 5 13 3 30 3h34l11-2 6-3 16-2 8-9 11-15 18-24v-2h2l8-12 7-9 1-4-1-2 5 1 9-4-10 14-14 23-11 16-9 10-9 11-7 6-6 3-19 1-4 2-7 11-8 11-9 10-4 5-2 5v12l3 7 3 4 7-1 7-9 7-7 14-9 13-7 10-7 8-6 18-18 10-13 7-11 5-5 10-11 1 1-9 10-4 6 1 1 9-1 33-16 15-10 2-2v-25l-2-1-9 7-10 9-11 9-8 5 17-16 12-11 14-10 15-10 11-6-17 12-7 6-1 2v13l4 18 8 14 6 9 9 17 7 21 1 4v9l-6 14 1 8 8 16 5 15 4 5 6 3 10 1 4-2-1-7-3-10-1-7-1-33-5-21-7-18-5-11-4-13-6-25-2-8v-9l29-29 8-10 10-14 1-4-2-1-25 16-15 10-7 4 5-5 5-6 1-4v-9l-4-8-8-5-12-3-23-3h-40l-4-2v-7l5-25 3-3 6-4 3-3 1-6 5 2 13 8 17 9 6 4h7l8-5 10-9 4-4v-2h2l7-8 14-15 9-11 10-10 6-4 5-2 7 1h11l10-4 3-5-7-2 3-8-1-3h-15l-1 1v5l-4 2-2 2h-12l-6 3-12 11-7 7-10 8-14 11-13 10-7 6-6-1-15-11-10-9-7-10-6-8-17-9-4-5 1-9 3-9 6-9 5-4 10 1 5 1h7l6-8 6-14 3-5-1-5-2-3 1-11v-13l-6-17-6-7-11-6-9-2h-15l-10 2-12 7h-12l-10 4-6 5-5 9-6 19-10 22-2 16-1 15-3 15 1 8-8 26-4 11-4 19-8 23-10 16-12 16-12 13-9 11-5 5v2h-2v2l-3 1h-9l-8-3-13 1v-4l-17-9-15-9-14-10-14-11-20-18-13-14-15-20-7-9-10-16-15-28-10-24-6-16-6-19-4-17-3-19-1-10v-50l4-28 6-25 8-26 11-26 12-23 8-13v-2z",
    fill: "#F80443"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1824,31)",
    d: "m0 0 16 4 16 7 14 8 13 10 8 9 1 2v6l-26 34-18 27-13 22-15 28-14 30-11 27-14 39-12 40-7 27-4 23-1 3-3 35 2 10v9l-4 4h-14l-15-4-12-6-7-7-7-8-8-9-5-12-3-22v-13l4-27 9-36 11-35 17-47 16-40 14-32 12-25 13-25 10-17 14-21 8-10 6-5z",
    fill: "#0989F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1277,195)",
    d: "m0 0h10l10 6 10 9 8 11 2 4h2l5-8 3-1 19 5 11 6 7 8v6l-13 29-10 27-6 19-6 26-1 7v21l4 10 10 9-2 4-18 8-10 3h-15l-10-5-5-6-5-12-2-13v-7l3-11h-3l-2 6-7 10-11 13-10 10-12 9-13 6-3 1h-9l-12-5-8-7-7-10-5-12-3-16v-13l3-20 5-18 10-24 10-18 8-12 9-12 11-12 11-11 17-12 13-6zm6 72-13 13-8 10-6 8-8 12-8 15-5 16 1 2 13-17 10-15 12-19 13-23z",
    fill: "#0989F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,598)",
    d: "m0 0h32l14 3 16 7 13 9 12 10 4 7v7l-7 24-5 14-7 8-4 2h-12l-10-5-5-6-5-16-4-5-10-5-7-2h-16l-10 3-10 6-8 8-6 12-2 8v21l4 13 5 10 10 11 11 7 13 5 7 1h17l13-2 10-4 14-10 9-6 8-1 10 4 10 9 2 4v9l-6 10-12 14-7 7-13 10-14 8-17 6-16 3h-17l-19-3-17-6-15-8-13-10-5-4-9-11-7-10-8-15-5-17-2-11v-31l4-17 5-13 8-15 8-10 8-9 10-8 15-9 15-6 16-4z",
    fill: "#0889F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1116,189)",
    d: "m0 0h11l12 4 10 6 10 9 6 7 1 2-1 15-4 20-6 16-6 12-10 14-14 14-15 11-18 10-19 9-15 6h-2l1 20 4 11 2 2 9 1 12-3 16-8 12-9 12-11 18-18 4 1 12 12-1 4-9 11-11 12-11 11-14 11-15 10-19 9-8 2h-7l-15-4-16-8-9-7-9-10-6-10-4-11-2-10v-22l3-17 4-14 6-16 8-16 6-11 10-14 12-14 12-12 10-8 13-8 15-7zm-10 73m-1 1m-1 1m-1 1-2 4 3-2zm-4 4-3 4 1 2 4-5z",
    fill: "#0989F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(181,234)",
    d: "m0 0h6l3 2 3 7-2 11-10 17-9 19-9 23-9 32-4 23-2 18v34l3 26 5 23 10 30 11 26 14 27 10 15 14 19 8 10 9 10 17 17 14 11 16 12 18 11 19 11 4 2h11l7-7 7-8 10-11 13-17 10-15 6-15 9-34 5-15 3-15 2-17 2-12 2-20 3-12 9-20 7-21 7-9 12-6 18-3 13-6 10-2h27l13 4 11 7 6 8 5 16 1 28v20l-3 7-9 19-3 3-6 1h-21l-8 11 3 3 16 10 10 12 8 10 11 9 5-1 18-14 13-11 10-9 9-9 7-5 3-1-4-1v-15l-1-7-6-6v-18l2-4 13-5 8-10 3-2h16l5 4 4 6 6 4 7 2 4 5v18l-8 7v11l5 2v9l3 1 1 3v19l-2 3h-3l1-4-3-8-6 7-7 3-24 1-9 6-7 8-5 5-8 10h-2l-2 4-14 15-13 13-9 6-3 1h-8l-15-9-9-4-10-6-4-1-2 4-9 7h-2l-1 14-3 10v7l2 1h35l24 3 15 3 10 5 3 4 1 4v14l7-2 11-8 11-7 6-3 4 2-7 14-14 17-9 10-8 7-12 12 2 10 4 18 4 14 5 15 6 15 6 20 3 13 1 36 3 11-1 3-4-12-1-7-1-33-5-21-7-18-5-11-4-13-6-25-2-8v-9l29-29 8-10 10-14 1-4-9 5-29 19-8 5h-2l1-3 6-5 3-7v-9l-4-8-10-5-17-3-15-2h-40l-5-3v-7l5-25 4-4 6-4 2-2 2-7 5 2 13 8 17 9 6 4h7l8-5 10-9 4-5h2l2-4 10-10 7-8 12-14 9-9 6-4 5-2 7 1h11l10-4 2-4-7-2 3-8v-2h-15l-1 5-6 5h-12l-6 3-12 11-7 7-10 8-14 11-13 10-7 6-6-1-15-11-10-9-8-11-5-7-17-9-5-6 1-9 3-9 6-9 6-5 10 1 5 1h7l6-9 5-12 3-5-1-5-2-3 1-11v-13l-6-17-5-6-11-6-9-2h-15l-10 2-12 7h-12l-10 4-5 4-5 9-6 19-10 22-2 16-1 15-3 15 1 8-8 26-4 11-4 19-8 23-10 16-12 16-12 13-9 11-6 7h-2v2l-3 2h-9l-8-3-14 1 1-5-6-2-11-6-15-9-14-10-14-11-20-18-7-7-9-11-13-17-7-9-10-16-15-28-10-24-6-16-6-19-4-17-3-19-1-10v-50l4-28 6-25 8-26 11-26 12-23 8-13 1-2-6 1z",
    fill: "#F70443"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1863,179)",
    d: "m0 0h23l16 4 10 4 10 6 11 10 2 3 6-10 4-4 4-1h12l17 1 20 6 13 7 8 7 2 4-1 7-7 16-12 27-12 29-10 27-12 36-10 28-11 26-12 25-12 21-11 16-10 13-8 10-7 7-7 8-14 13-16 11-17 9-14 5-16 3h-23l-18-4-19-7-16-9-10-8-9-10-3-6v-7l4-9 7-8 7-5 6-1 10 5 11 8 2 1h13l12-3 17-8 12-9 12-11 12-13 13-18 10-16 2-4-2 1h-19l-17-5-15-8-11-9-8-10-5-10-1-4v-19l4-24 8-26 9-24 10-22 11-20 13-20 9-11 9-10 9-8zm16 8-7 4-6 5v2h-2l-7 8-10 13-10 15-12 22-11 25-7 18-8 27-4 22v19l4 10 7 9 7 6 8 5 12 5 9 2 9-1 12-7 10-9 9-9 9-11 7-10 13-24-3 10-10 23-8 20-10 21-10 18-9 14-10 14-9 11-11 12-10 9-15 10-16 8-14 4-6 1h-8l-10-2-9-6-8-7-5 3-6 7-2 4 1 7 10 11 14 9 14 6 15 4 7 1h17l15-3 19-7 14-8 12-9 12-11 7-6 7-8 10-12 13-18 10-16 9-16 8-16 11-25 15-42 12-36 8-22 13-31 17-37v-6l-11-7-12-5-12-3-14-1-4 4-13 22-16 29-10 18-6 12-13 22-11 17-10 14-8 10-9 10-10 9-2 1 5-23 7-24 9-24 16-33 11-20 9-14 7-10 7-9 2-2-1-5-11-7-11-5-14-4zm50 28m-1 1-9 10-11 16-10 18-14 29-7 16 1 3 14-24 13-24 13-23 11-19z",
    fill: "#F76864"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1132,610)",
    d: "m0 0h11l4 4 1 5 1 117 3 14 6 9 5 4 10 5 12 3h14l17-4 16-7 5-3v-119l-2-4-9-6-3-4v-8l4-5 5-1h43l2 1 3 16 1 13 1 108 1 11 2 4 9 3 4 5v11l-8 6-25 13-8 4-3 1h-10l-4-2-2-4 1-10 1-2-11 6-21 10-14 4-6 1h-14l-14-3-15-6-15-10-14-14-6-10-4-12-1-7-1-86-9-4-5-4-1-8 4-6 11-10 16-12 9-6z",
    fill: "#0889F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,185)",
    d: "m0 0 8 1 17 6 15 8 8 6v2l3 1 1 3-10 13-11 19-8 14-1 4 7-6 1-2h2l1-3h2l2-4 12-12 13-17 11-15 5-4 4-1h10l11 4 6 4 3 3-1 8-5 20v25l3 11 1 7-7 12-11 12-3 4-4-1-11-7-13-11-9-13v-2l-5 2-12 9-12 11-9 10-12 18-9 19-10 30-9 36-1 1-8-1-13-5-11-7-9-8-4-7 3-16 6-24 11-38 14-41 9-25 9-22 8-16 8-11z",
    fill: "#0989F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1376,607)",
    d: "m0 0h26l26 3 11 4 4 4 1 3v38l-4 4h-14l-6-7-5-7-8-5-11-4-5-1h-17l-8 3-5 4-2 3v8l4 7 10 7 24 13 22 13 12 9 11 11 6 13 3 17v10l-4 15-6 10-9 10-11 7-9 4-17 4h-31l-24-4-15-4-5-5-5-25-1-10 4-6 9-4h6l10 9 16 8 16 5 5 1h15l10-5 4-6v-12l-6-8-11-7-27-14-20-12-12-11-7-9-5-10-3-12v-15l5-16 7-9 8-7 14-7 17-4z",
    fill: "#0889F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,599)",
    d: "m0 0h24l13 4 11 6 9 7 7 7 9 14 5 13 2 9 1 9 1 101 1 5 8 6 4 7v12l-4 8-5 4-6 2h-60l-8-3-5-5-3-7v-8l4-9 7-6 2-1 1-4v-93l-1-12-3-6-6-3h-14l-16 3-8 2 1 108 1 5 6 4 5 6 2 6-1 10-5 8-6 4-5 1h-58l-9-3-6-7-1-3v-13l6-9 6-4 1-2v-102l-2-9-2-3-7-2h-15l-14 3-10 3v85l1 27 8 6 4 6 1 8-2 9-6 7-9 3h-60l-8-3-5-6-2-6v-8l3-7 5-6 6-4 1-106-6-2-5-4-4-8v-13l4-6 10-9 18-13 10-7 10-4h7l9 3 6 5 7-1 18-6 11-2h27l13 4 12 7 9 7 5-2 16-8 16-6zm4 9-14 3-12 4-17 8-12 7-7-6-9-7-10-5-11-3h-21l-18 4-15 6-12 6v-9l-6-5-7-1-8 3-13 10-16 12-8 8-1 5 3 7 6 3 6 2v118l-8 6-5 5v10l5 5h24l39-1 4-5v-9l-8-7-5-5-1-121 9-3 16-5 6-1h19l9 2 6 4 3 7 1 5v113l-4 4-8 5-1 2v10l5 5h23l39-1 5-4 1-7-2-5-11-8-1-2-1-107-1-15 10-3 14-4 7-1h19l9 3 5 6 2 7 1 9v106l-4 4-8 5-1 2v10l4 5h26l37-1 4-3 1-3v-7l-5-6-8-6-1-12-1-103-3-15-7-14-11-12-8-6-8-4-9-3-5-1z",
    fill: "#F5312D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1438,176)",
    d: "m0 0 12 3 13 5 16 9 11 9 7 6 3 4v6 2l9-7 14-8 12-4 6-1h9l4 1 11 2 17 8 11 9 4 4 9-8 14-9 16-7 4-1h25l11 4 9 6 7 8 5 9v9l-10 24-15 33-13 30-9 25-4 13h8l6 2 8 7 5 10 1 3v11l-9 8-14 8-12 5-12 3h-13l-12-3-14-7-10-10-8-16-3-14v-20l1-10-13 18-10 14-13 18-14 19-7 8-2 1h-8l-16-8-10-8-8-10-7-14-1-3v-9l5-25-9 11-9 13-8 12-12 17-7 9-9 10-6 5h-9l-6-4-11-10-7-10-5-10-5-19v-10l5-28 7-25 9-25 8-19 24-48 10-18 7-10zm3 10-6 9-12 22-12 23-13 27-11 28-8 27-5 25-1 8v11l6 18 7 11 5 6 8 6 4-1 11-12 14-20 15-22 12-17 10-13 13-17 9-10 22-28 4-3-12 19-8 16-11 30-6 22-4 18 2 8 6 11 9 10 13 8h5l13-16 12-17 13-18 10-14 13-18 10-14 11-14 11-13 8-10 2 1-8 14-11 27-7 25-2 15v11l3 15 4 10 7 9 5 4 8 4 4 1h18l13-4 11-6 9-7 2-2-1-9-4-7-2-1-11 1-10 2v-14l5-21 9-24 16-35 13-28 8-20-1-7-7-10-9-6-11-3h-9l-13 4-10 5-14 10-13 12-23 23-8 11-8 10 1-3 6-10 8-13 8-18 2-6-1-6-8-7-15-7-12-3h-7l-13 4-11 6-13 10-10 9-21 21-7 8-12 15-12 17-8 11v2h-2l6-12 13-19 12-17 8-13 10-19 6-15-1-4-11-10-14-9-15-6zm24 149 1 2z",
    fill: "#F66764"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1511,601)",
    d: "m0 0h7l12 5 7 8 2 8 1 153 5 2 6 7 2 5v7l-3 9-7 6-7 2h-58l-9-3-6-7-1-3v-12l4-8 8-6 1-2 1-105-5-2-6-5-4-9v-9l4-8 9-8 19-14 13-9z",
    fill: "#0989F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(648,71)",
    d: "m0 0h55l26 5 24 8 20 10 12 8 11 9 10 9 10 11 10 15 8 16 5 14 4 17 1 8v35l-3 21-5 21-9 25-10 21-10 16-10 14-12 14-18 18-11 9-17 12-27 14-16 6-23 6-11 2h-43l-16-3-17-6-17-9-11-8-13-13-10-14-5-10v-9l16-38 13-33 19-49 8-22v-1h-16l-16-7-11-8-9-10-7-14-2-6v-10l6-18 8-15 7-9 11-12 13-11 19-11 15-7 14-5 13-3zm15 8-21 2-19 4-16 5-12 5-15 8-13 10-10 9-8 10-9 14-6 16-1 10 5 13 7 10 9 8 13 7 5-1 7-19 12-25 10-14 6-7v-2l4-2 12-10 6-3-10 28-8 23-14 37-22 57-8 21-21 52-9 21 1 5 10 16 11 12 10 8 13 8 17 7 18 4 9 1h22l22-3 21-6 15-6 16-8 11-7 16-12 17-16 8-8 11-14 12-18 8-14 10-23 7-22 5-26 1-11v-26l-2-15-5-19-6-15-6-11-10-14-11-12-9-8-15-10-14-8-18-7-18-5-19-3-11-1z",
    fill: "#F66663"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1824,31)",
    d: "m0 0 16 4 16 7 14 8 13 10 8 9 1 2v6l-26 34-18 27-13 22-15 28-14 30-11 27-14 39-12 40-7 27-4 23-1 3-3 35 2 10v9l-4 4h-14l-15-4-12-6-7-7-7-8-8-9-5-12-3-22v-13l4-27 9-36 11-35 17-47 16-40 14-32 12-25 13-25 10-17 14-21 8-10 6-5zm3 10-9 11-14 21-14 24-16 32-13 29-13 32-15 40-13 37-12 40-6 25-3 20v23l4 18 5 10 7 7 7 8 5 4 13 4 7 1v-35l3-21 5-25 8-31 8-26 13-38 10-26 13-30 16-32 13-22 13-20 14-20 20-26-1-5-14-11-15-9-21-9z",
    fill: "#F76864"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,112)",
    d: "m0 0h25l17 2 21 6 12 6 9 7 10 10 8 14 5 16 2 13v21l-2 18-4 20-5 17-8 19-8 16-10 15-9 11-9 10-10 10-13 10-19 11-16 7-18 5-12 2-12 1h-17l-10-1-1-1v-8l11-33 11-27 13-30 16-36 16-33 9-19 24-44 6-10-1-3-14-10-18-10zm44 14 6 8 1 4-5 10-12 20-15 29-14 28-15 33-14 31-16 38-10 28-2 10 2 2 6 1 26-3 15-4 18-8 16-10 11-10 8-7 8-9 10-13 10-16 8-16 7-19 3-10 3-17 2-13v-28l-2-9-4-14-7-13-11-11-14-8-10-3z",
    fill: "#F66864"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,598)",
    d: "m0 0h32l14 3 16 7 13 9 12 10 4 7v7l-7 24-5 14-7 8-4 2h-12l-10-5-5-6-5-16-4-5-10-5-7-2h-16l-10 3-10 6-8 8-6 12-2 8v21l4 13 5 10 10 11 11 7 13 5 7 1h17l13-2 10-4 14-10 9-6 8-1 10 4 10 9 2 4v9l-6 10-12 14-7 7-13 10-14 8-17 6-16 3h-17l-19-3-17-6-15-8-13-10-5-4-9-11-7-10-8-15-5-17-2-11v-31l4-17 5-13 8-15 8-10 8-9 10-8 15-9 15-6 16-4zm1 9-18 4-12 4-15 8-9 7-10 9-9 12-8 16-5 15-2 10v28l4 18 5 13 8 14 13 15 14 11 15 8 18 6 14 2h16l19-4 16-7 14-9 12-11 7-7 9-13-1-6-7-6-5-3-6 1-15 12-15 7-12 3-9 1h-11l-16-3-16-7-11-8-8-10-6-11-4-11-2-9v-16l2-10 5-12 7-11 13-10 13-5 4-1h19l14 4 11 7 4 7 4 16 4 4 4 1h9l5-6 8-24 3-13-7-8-14-11-12-6-13-4-6-1z",
    fill: "#F5312E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1375,598)",
    d: "m0 0h32l23 3 12 4 8 7 3 8 1 8v27l-3 10-7 6-6 2-13-1-6-3-6-7-7-8-12-5-4-1h-14l-5 3v5l-1 1 8 6 27 15 20 12 13 10 9 9 8 13 4 12 1 6v17l-3 14-8 16-11 12-14 9-16 6-21 3h-14l-23-3-23-5-9-4-6-6-4-26-1-5v-15l7-8 8-4 4-1h9l7 4 7 7 14 7 14 4 14 1 8-3 1-2v-6l-4-5-18-10-28-15-13-9-15-15-8-13-4-12-1-7v-15l4-16 6-10 9-10 11-7 14-6 13-3zm1 9-17 3-14 5-11 7-7 7-5 8-4 14v15l3 12 5 10 7 9 8 8 14 9 18 10 23 12 9 7 4 6v12l-5 7-9 4h-15l-19-5-16-8-8-7-4-3-9 1-6 3-4 6 1 10 5 25 5 5 15 4 24 4h31l17-4 16-8 9-8 8-11 4-10 2-9v-10l-3-17-7-14-12-12-15-10-23-13-18-10-10-7-4-7v-8l4-5 7-4 4-1h17l13 4 8 4 5 4 7 10 2 2h14l4-4v-38l-3-6-9-4-18-3-12-1z",
    fill: "#F5322E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,641)",
    d: "m0 0h24l28 4 11 4 5 4 3 7v9l-3 7-7 6-1 2 18-11 15-10 14-9 2 1-2 5-9 13-12 14-25 25v9l6 25 6 21 8 18 6 18 3 14 1 33 3 14 2 5v5l-4 2-10-1-7-4-4-7-6-17-7-14 1-8 5-11v-9l-6-20-8-17-16-26-3-9-2-11v-13l5-6 17-12 2-2-13 8-5 2v-2l13-8 12-9 6-5 3-10-4-12-8-4-12-3-19-2h-42v-2z",
    fill: "#FCFCFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1511,601)",
    d: "m0 0h7l12 5 7 8 2 8 1 153 5 2 6 7 2 5v7l-3 9-7 6-7 2h-58l-9-3-6-7-1-3v-12l4-8 8-6 1-2 1-105-5-2-6-5-4-9v-9l4-8 9-8 19-14 13-9zm1 9-14 10-19 14-8 7-1 2v8l3 5 9 3h3v115l-2 5-11 8-1 3v9l4 5h25l39-1 4-4 1-8-3-5-10-7-1-4-1-156-4-5-9-4z",
    fill: "#F6322D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,556)",
    d: "m0 0 4 2 2 4 2 19v13l-3 19-6 16-9 11-9 14-6 16-1 5v10l2 9 5 8 4 2 35 1-1 2-46 1-24-4-24-5-10-3h-14l3-3 7-3 5-5 12-11 36-36 9-12 10-24 16-45zm-33 97m-1 1m-1 1-11 12-16 16-6 4 2 2 27 6 2-1v-22l2-13 1-4z",
    fill: "#F80142"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1817,33)",
    d: "m0 0h6l-2 4-13 17-9 15-10 16-7 14-10 19-7 16-6 12-12 28-12 31-16 44-14 43-9 35-3 15-1 11v20l3 17 3 9 6 10 9 10 5 5v4l-5-2-8-7-9-10-7-8-5-12-3-22v-13l4-27 9-36 11-35 17-47 16-40 14-32 12-25 13-25 10-17 14-21 8-10 6-5z",
    fill: "#B94950"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1515,494)",
    d: "m0 0h12l7 6 3 7 1 7v25l-3 8-4 5-17 8-13 5-9 1-6-3-5-6-2-6-1-7v-25l3-7 4-5 16-8z",
    fill: "#0889F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,535)",
    d: "m0 0 2 3 2 8-2 3 2 1-7 4-4 1-22 1-9 6-9 9-9 11-15 16-21 21-5 3-6 1h-13l-14-5v-3h-4v-2l-11-3-4-4-5 1-3 3-5 2-2 13-3 9h37l32 3 10 3 7 6 4 6 1 8 6-3 11-8 4-1h7l4 3-1 2-7 2-10 7-15 10h-5l-1-14-2-5-1-3-5-2-8-3-26-4-10-1h-35l-3-2v-7l3-10 2-14 11-8 2-3 6 1 11 7 10 4 11 7h8l8-4 12-11 13-13 8-10h2l2-4 6-7 7-8 7-7 7-4 24-1 8-4 4-5z",
    fill: "#F70343"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(704,122)",
    d: "m0 0h7l10 3-4 2 5 5 2 3-1 6-16 27-15 29-14 28-15 33-14 31-16 38-10 28-2 10 7 2 26-3 9-1-3 2-15 3-16 2-17 1-4-1 1-9 8-24 12-29 13-30 18-40 13-28 10-19 10-20 16-27 4-8-2-5-4-4v-2h-2z",
    fill: "#B7474F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1863,179)",
    d: "m0 0h23v1l-14 1-19 19-6 8-12 18-8 14-10 19-7 15-11 28-7 24-3 17-1 9v16l5 13 8 11 11 8-4 2-5-2-11-8-9-10-6-12-1-4v-19l4-24 8-26 9-24 10-22 11-20 13-20 9-11 9-10 9-8z",
    fill: "#B94850"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1308,241)",
    d: "m0 0h2l-1 5-8 16-15 27-14 23-10 15-9 13-9 11-7 8-10 7-4 1-1-5 3-20 6-17 8-16 9-15 10-13 9-10 12-12 13-9zm-25 26-13 13-8 10-6 8-8 12-8 15-5 16 1 2 13-17 10-15 12-19 13-23z",
    fill: "#F66863"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,688)",
    d: "m0 0 2 1-11 8-12 9-2 3v13l4 18 8 14 6 9 9 17 7 21 1 4v9l-6 14 1 8 1 4-3-3-1-3v-8l5-11 1-7-5-17-9-20-9-16-7-10-3-6v-3l-3 1-5 6-16 10-12 6-21 9-12 3-11 15-7 9-15 15-26 16-14 8-12 11-7 8-2 1h-7l-4-4-2-4-1-6v-9l4-10 12-12 8-12 2-7h-40v-1l34-1 11-2 6-3 16-2 7-8 11-15 12-16 7-10h2l2-5 7-9 6-9v-4l8-1 3-2h3l-2 5-8 10-8 14-16 24-9 10-9 11-8 7-6 3-19 1-3 1-7 11-8 11-9 10-4 5-2 5v12l3 7 2 3 7-1 6-8 8-8 14-9 13-7 10-7 8-6 13-13h2l2-4 10-13 7-11 3-1 2-4 11-12 3 1-11 12-3 5 9-1 33-16 15-10 1-1v-25l-7 4-15 14-16 12-2-1 7-7 8-7 15-14 14-10 15-10z",
    fill: "#FA6A65"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,90)",
    d: "m0 0 6 2 15 9 13 11 8 7 11 12 10 15 8 16 5 14 4 17 1 8v35l-3 21-5 21-9 25-10 21-10 16-10 14-12 14-18 18-11 9-11 8-2-1 13-10 4-4-1-2h2l2-4 3-1 2-4 9-9h2l2-5 9-10 13-20 11-20 9-21 7-23 5-26 1-18v-20l-2-17-4-17-8-19-8-13-8-11-25-25-5-4-13-8z",
    fill: "#B84950"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1949,191)",
    d: "m0 0h12l17 1v1l-22 1-1 4-10 17-14 25-10 19-6 10-6 11-11 19-13 21-11 15-8 7-1-4 7-22 2-4h2v-6l2 1 12-22 12-21 16-29 13-22v-2l3-3 7-12 4-4z",
    fill: "#B7474F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,413)",
    d: "m0 0h15l13 4 10 7 4 5 3 5 3 11 2 7v9l-1 10 1 10-13 26-5 3h-7l-8-2h-6l-6 5-4 6-2 2-1 16 4 3 6 3 7 4 5 4 11 15 11 11 11 8 3 2h6l-2 3-6-1-15-11-10-9-8-11-5-7-17-9-5-6 1-9 3-9 6-9 6-5 10 1 5 1h7l6-9 5-12 3-5-1-5-2-3 1-11v-13l-6-17-5-6-11-6-9-2h-15l-10 2-12 7h-12l-10 4-5 4-5 9-6 19-10 22-2 16-1 15-3 15 1 8-8 26-4 11-4 19-8 23-10 16-12 16-12 13-9 11-6 7h-2v2l-3 2h-9l-8-3-14 1 1-5-6-2-11-6-15-9-14-10-14-11-20-18-7-7 1-2 12 12 11 9 12 10 11 7 8 7 11 6 11 7 10 5 2 4h12l11 3 5-1 1-2h2l2-4 7-7 3-5 9-8 4-6 5-6 11-15 6-11 6-16 4-16 5-18 3-7 5-20v-5l-1-4 4-18 2-24 3-10 4-8 8-20 3-12 7-8 5-4 10-4 15-1 10-6z",
    fill: "#FA6A65"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,405)",
    d: "m0 0h27l13 4 11 7 6 8 5 16 1 28v20l-3 7-5 11-1-3 6-13 1-21-1-27-2-6-2-3-1-3-5-9-7-6-8-4-9-2v-1l-6-1h-14l-15 2-19 9-10 1-12 6-4 4-4 18-4 12-6 10-4 10-3 33-3 14-1 15-4 13-3 7-2 4-2 13-2 8-5 18-4 8-5 8-2 1-3 5-3 3h-2v2h-2l-2 5-7 6-4 8-4 5-6 5-3 5h-2v2l-5 5-3 2h-8l-7-3 3-1h11l7-7 7-8 10-11 13-17 10-15 6-15 9-34 5-15 3-15 2-17 2-12 2-20 3-12 9-20 7-21 7-9 12-6 18-3 13-6z",
    fill: "#D90B3C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1878,392)",
    d: "m0 0 1 4-8 14-6 11-14 21-6 8-7 8-14 15-13 11-13 8-9 4-18 4h-11l-7-2v-2l-5-2-1-2 4 1h13l12-3 17-8 12-9 12-11 12-13 13-18 10-16 5-7 11-8 9-7z",
    fill: "#B8484F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,520)",
    d: "m0 0h9l5 2v8l4 4-1 5-7 6-5 2-24 1-9 6-7 8-5 5-8 10h-2l-2 4-14 15-13 13-9 6-3 1h-8l-15-9-9-4-10-6-4-1-2 4-9 7h-2l-1 14-3 10v7l2 1h35l24 3 15 3 10 5 3 4 1 4v14l7-2 11-8 11-7 6-3 4 2-7 14-14 17-9 10-8 7-12 12 2 10 4 18 4 14 5 15 6 15 6 20 3 13 1 36 3 11-1 3-4-12-1-7-1-33-5-21-7-18-5-11-4-13-6-25-2-8v-9l29-29 8-10 10-14 1-4-9 5-29 19-8 5h-2l1-3 6-5 3-7v-9l-4-8-10-5-17-3-15-2h-40l-5-3v-7l5-25 4-4 6-4 2-2 2-7 5 2 13 8 17 9 6 4h7l8-5 10-9 4-5h2l2-4 10-10 7-8 12-14 9-9 6-4 5-2 7 1h11l10-4 2-4-7-2 3-8v-2h-15l-1 5-6 5h-12l-6 3-12 11-7 7-10 8-6 5-2-1 12-11 8-7 11-11h2v-2l8-5 13-1 5-8z",
    fill: "#FA6A65"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1515,494)",
    d: "m0 0h12l7 6 3 7 1 7v25l-3 8-4 5-17 8-13 5-9 1-6-3-5-6-2-6-1-7v-25l3-7 4-5 16-8zm7 8-16 5-16 7-2 2-1 4v18l1 13 2 5 7 1 26-11 5-4 1-4v-14l-1-13-3-8z",
    fill: "#F4312E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,246)",
    d: "m0 0 2 1-8 8-3 5-6 7-5 5-7 8-2 4h-2l-2 5-3 4-3 6h-2l-2 5-6 11-5 8-3 5-1 5-5 9-5 10-3 11-4 10-6 17-9 36-4 23v14l-2 18 1 15 1 31 1 1 4 24 3 8 3 12 1 9 4 9 4 11v3l2 1 4 11 5 10 2 8-2 1-11-24-9-24-6-21-6-26-4-25-2-23v-20l2-30 6-31 8-30 10-27 12-25 11-20 10-15 9-12 9-11 12-13z",
    fill: "#D80E3D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,240)",
    d: "m0 0 4 1-3 12-8 16-10 13-15 15-14 10-10 6h-2l1-6 8-18 9-14 11-14 9-9 10-7zm-15 22m-1 1m-1 1m-1 1-2 4 3-2zm-4 4-3 4 1 2 4-5z",
    fill: "#F66864"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,268)",
    d: "m0 0v3l-8 8-11 14-8 11-9 14-9 15-12 25-10 26-5 17-6 26-4 26-1 20v21l1 18 5 30 8 31 8 22 11 25 10 19 10 16 12 16 9 11 7 7 7 8 8 8 8 7 13 11 11 8 16 11 21 12 25 12 15 5 17 6 23 5 13 3v1l-10-1-28-6-32-11-17-8-16-8-16-10-15-10-11-9-10-8-13-12-19-19-10-13-7-10-12-18-12-22-9-20-11-30-7-29-5-25-1-7-1-17v-19l1-22 4-25 7-28 9-27 8-19 10-20 9-14 5-9 10-15 13-15 7-8z",
    fill: "#FA6A65"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,712)",
    d: "m0 0 2 1v25l-9 7-16 9-25 12-9 1v-3l7-8 6-7-4 2-4 3 2-5 1-2h2v-2l9-7 5-5 6-5h2l2-4 9-7 2 1-15 14-11 10 9-6 10-8 7-7z",
    fill: "#FDFCFC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1029,645)",
    d: "m0 0 6 3 11 16h3l2-2 1 1v109l-4-4-1-2-1-16v-19l-1-13-4-15-3-8-2-18-3-1-6-19 1-11z",
    fill: "#0092FD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,466)",
    d: "m0 0h3l5 10 4 3 9 1 3 2-1 4-8 8 1 16-3 1-8-4h-8l-9 5h-2l-1-3 1-6v-8l-8-10 1-4 12-3 6-8z",
    fill: "#FDFDFD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(436,556)",
    d: "m0 0 4 2 2 4 2 19v13l-3 19-6 16-9 11-9 14-6 16-1 5v10l2 9 5 8 4 2 35 1-1 2-46 1-24-4-24-5-10-3h-14l3-3 7-3 5-5 12-11 36-36 9-12 10-24 16-45zm1 9-3 4-6 14-8 24-8 19-5 6-9 11-5 4-7 8-9 10-6 5v2h-2v2l-4 2-9 8v2l-5 2-2 5 21 6 27 5 18 2-5-8-3-11v-12l5-16 4-9 6-8v-2h2l7-9 5-11 5-22v-25l-2-8z",
    fill: "#FA6A65"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(479,702)",
    d: "m0 0h3l-2 5-8 10-8 14-16 24-9 10-9 11-8 7-6 3-19 1-3 1-6 9h-2l1-7h-40v-1l34-1 11-2 6-3 16-2 7-8 11-15 12-16 7-10h2l2-5 7-9 6-9v-4l8-1z",
    fill: "#FA6964"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,631)",
    d: "m0 0 3 1 6 8 9 2v2l-2 1-5 11-1 23-1 6-8 5-3-1v-2h-2l-3-9-2-16-1-12v-8l5-5 3-5z",
    fill: "#0093FE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1433,180)",
    d: "m0 0h2l-2 5-14 26-10 19-12 24-14 33-10 30-4 17-1 2h-2v8l-1 2-1 9v10l2 5 2 10 1 3h2l7 15-3-1-6-9-5-13-3-13v-10l5-28 7-25 9-25 8-19 24-48 4-7 2-1 12-18z",
    fill: "#BA4950"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,643)",
    d: "m0 0 10 1-1 9-2 5v12l1 4h-2l-1 6-3 7-3 1-7-2-3-6-2-13-3-9v-7l4-5 10-2z",
    fill: "#0093FE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,646)",
    d: "m0 0 1 2-4 9-3 9-2 5-1 5v12l4 10 6 4 17 1h26l11-2 12-12 9-7 6-3h5l1 2-2 3h-3l-2 4-8 7-11 12-3 3h-2l-1 4-3 4h-2l-1 5-10 16h-2l2-5 9-15 8-11 4-6-9 4-5-1 1 4-7 10-3 2 1-4 4-5 1-3h-62l-10-2-2-2h7l11 2 46-1-34-1-5-3-5-8-2-9v-10l4-13 5-12z",
    fill: "#E7E6E6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,284)",
    d: "m0 0 4 4-4 2-8 7-6 5-9 11-10 15-9 20-8 25-8 32-3 1-2 5-3 1 1-9 13-45 6-17 8-17 8-11 11-13 4-2v-2l10-8 1-2z",
    fill: "#B94951"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1261,622)",
    d: "m0 0 6 1 6 3 1 7 1 1 1-3 3-1 1 13-4 1-2 6v16l-2 7-4 1-3-4-4-17-6-17-1-6 4-6z",
    fill: "#0093FE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,523)",
    d: "m0 0h15l1 3-3 8 7 2-3 5-10 4h-11l-7-1-5 2-9 7-9 9-9 11-15 16-4 5h-2l-2 4-9 9-9 6-2 1h-7l-3-3 8 1 5-1v-2l6-5h2v-2h2l1-3h2v-2l3-3h2l2-4 4-4h2v-2h2l2-4 15-16 9-11 7-6h2l1-6 13-2h8v-3l-7-1h-11l-9 4-10 9-2-1 8-8 7-5 3-1h12l4-4h2v-5z",
    fill: "#E8E7E7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,149)",
    d: "m0 0h2l-3 9-9 25-7 19-6 15-2 4-1-1h-14l4-2 2-2 4-13 10-25 8-14 10-13z",
    fill: "#B7474F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,605)",
    d: "m0 0 5 1 3 3 11 4v2h4v3l5 1 9 3h18l-3 2h-22l-12-6-15-8-3-1v2l-6 3-3 16 38 1 18 2 18 4 8 4 4 5 2 4v6l11-8 6-4 8 1v1l-9 1-5 6-10 7-3 1-1-1-1-8-5-7-5-4-10-3-32-3h-34l-3-1 1-7 1-2 1-9 2-4 5-3h2z",
    fill: "#D8103D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,241)",
    d: "m0 0 1 2-12 21-9 19-9 24-9 33-3 21-2 28v33l4 41 9 32 5 13 5 12-1 3-9-21-9-28-4-17-3-19-1-10v-50l4-28 6-25 8-26 11-26 12-23z",
    fill: "#FA6A65"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,592)",
    d: "m0 0 2 1-3 14-6 15-2 4-2 5-7 9-7 11-3 7-1 9-1 3v29l-4-1-19-5-16-3 2-4 5-2-2 4 28 6v-22l2-13v-2l-7 8v-3l7-8 5-8 8-11 6-11h2l3-9 5-12 4-10z",
    fill: "#DC0038"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(384,651)",
    d: "m0 0 2 2-30 30-7 5-4 4-7 3h14l2 2-15 1-9 3h-7l-8-2-6-4-9-2-2-1v-2h-2l1-5 7-6-4-3-9-5-1-2 5 2 12 6v4h6l-4 2v2l4 2 3 2 11 1h3l16-1 2-4 6-4 2-3h2v-2l8-7 8-8h2v-2l5-5z",
    fill: "#E7E3E3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1581,317)",
    d: "m0 0 2 1-3 7-4 23v24l4 15 6 11 3 4 1 5-4-2-8-8-8-16-3-14v-20l2-11 3-7z",
    fill: "#BA4951"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,649)",
    d: "m0 0 3 1 7 10 9 12 7 10 4 4 5 7 8 7 21 21 10 8 10 7v2l5 2 11 8 10 5 8 5 14 7 11 6 9 4 9 2 6 3 7 3 2 2-7-1-22-8-24-11-18-10-15-10-19-14-10-9-8-7-24-24-11-14-13-18-5-8z",
    fill: "#DA1841"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,630)",
    d: "m0 0h4v9l-2 12-1 16-2 5-5 1-4-5-3-13-2-4v-13l3-5 2-2 8 1z",
    fill: "#0093FE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1725,479)",
    d: "m0 0 6 1 6 3-1 2-10 5-8 9-3 8v7l6 9 7 6 4 5 4 4-5-2-13-9-8-8-6-10v-7l4-9 7-8 7-5z",
    fill: "#B94B52"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,320)",
    d: "m0 0h2l-2 10-6 25-4 31v34l3 26 5 23 7 22v3h-2l-12-36-2-13-1-2-1-14-2-5v-37l4-28 3-13z",
    fill: "#D6103D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1477,318)",
    d: "m0 0 1 3-7 21-5 23v10l8 16 5 5 9 8 1 4-4-1-10-8-8-10-7-14-1-3v-9l6-26 1-5 8-10z",
    fill: "#B9484F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,749)",
    d: "m0 0 4 1v7l4 2 2 4h2l5 10 6 10 4 9 4 13 1 7-2 5-2 16v4h-2l2 9 6 8 5 16 1 8-3-4-4-10-4-11-5-9-1-4v-23l3-5 1-6-6-16-8-16-7-12-5-8-5 3-2-1z",
    fill: "#D5113D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,462)",
    d: "m0 0 4 1 8 13 15 4 1 1v5l-8 7-1 2-1 18-4 1-9-4h-8l-8 4h-7l2-18-6-7-4-3 1-5 7-3 8-2 7-11zm0 4-8 11-3 2-10 2-1 4 8 10v8l-1 7 1 2 6-2 5-3h8l8 4 3-1v-7l-1-9 6-5 3-4v-3l-3-2-9-1-5-4-4-9z",
    fill: "#FA6A65"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,511)",
    d: "m0 0 3 1-4 5-6 1h-21l-8 11 3 3 16 10 10 12 8 10 11 9 5-1 10-8 2 1-4 5-8 7-4 1-4-5-10-5v-2l-4-2-6-6-4-7-3-5-10-6-6-3-7-5 1-5 6-7 4-5 7-1h16z",
    fill: "#D80D3C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,416)",
    d: "m0 0h15l12 3 10 7 5 7 5 15v13l-1 11 3 4-1 6-11 22-3 3h-7l-9-2h-6l-7 6-6 11-2 8h-1l1-9 3-7 4-6 7-6 2-1h7l12 2 3-2 5-10 4-15-1-10 1-3-1-15-2-9-5-10-1-3-6-2-6-3-12-3h-9l-12 1 3-2z",
    fill: "#E7E6E6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,419)",
    d: "m0 0h2v2l-16 8h-12l-5 3h-3l-7 14-3 11-3 8-2 6-6 10-2 8v9l-1 5v8l-1 4-1 9-1 1v14l-8 24-4 11-2 10-2 1 1-10 9-27 3-10-1-8 3-15 2-23 2-11 9-19 7-21 6-9 6-4 8-3h12z",
    fill: "#E7E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(374,795)",
    d: "m0 0h3l-1 5-5 5-5 6h-2l-2 4-3 4-2 23 2 16h-3l-3-7v-31l4-7 11-12 2-1-40-2-4-2z",
    fill: "#D80A3B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1291,259)",
    d: "m0 0 2 1-7 11-4 10-18 30-14 20-5 7h-2v2h-4l-2 5-5 5 1-7 3-9 1 4v2l11-14 10-15 12-19 13-23 1-4z",
    fill: "#BA4B52"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(525,716)",
    d: "m0 0 2 1-6 7-5 5h-2l-2 4-5 7-15 10h-2v2h-2l-2 4-6 5-1 3 8-1-4 3-9 1v-3l7-8 6-7-4 2-4 3 2-5 1-2h2v-2l9-7 5-5 6-5h2l2-4 9-7 2 1-15 14-11 10 9-6 10-8 7-7z",
    fill: "#E7E6E6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,631)",
    d: "m0 0h1l1 19 1 105 8 4 4 3 2-7h1l2 18 3 17v6l-2-4-2-10v9h-2l-1-3-5 5-2-1 6-7v-14l-2-7-6-5-6-2-1-2zm16 133 1 2z",
    fill: "#B7474F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,460)",
    d: "m0 0 2 1 4 16 3 7v7l-3 5-3 2h-10l-2-1 1-6 3-10 2-3 1-14z",
    fill: "#FA6A65"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1527,619)",
    d: "m0 0h1v37h-9l-4-5-3-3-1-5 2-5 8-4 3-7z",
    fill: "#0093FE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,405)",
    d: "m0 0h27l13 4 11 7 6 8 5 16 1 28v20l-3 7-5 11-1-3 6-13 1-21-1-27-2-6-2-3-1-3-5-9-7-6-8-4-9-2v-1l-6-1h-14l-15 2-16 7-21 3 2-2 7-2 14-2 13-6z",
    fill: "#E35E5D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,516)",
    d: "m0 0 3 1-2 6-9 4-14 1-6 4-6 5-4 5-7 6-4 2-5 5-5 1 5-5 16-15 7-7 7-5 3-1-4-1v-5l1 3 7-2 5-1h7z",
    fill: "#DD0038"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1378,625)",
    d: "m0 0h5v3l-2 2-12 2-5 4 1 5v2l-7 7-1 5-4-1-3-6-4-1 1-6 5-4 11-8z",
    fill: "#0092FD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1620,651)",
    d: "m0 0 3 1v2l-5 5-6 9-5 12-2 10v23l-4-2-3-10v-14l4-14 4-7 5-3 3-6z",
    fill: "#0191FB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(50,525)",
    d: "m0 0 4 3 4 24 3 8 3 12 1 9 4 9 4 11v3l2 1 4 11 5 10 2 8-2 1-11-24-9-24-6-21-6-26-2-10z",
    fill: "#DB113E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,619)",
    d: "m0 0h1v7l-1 4 38 1 18 2 18 4 8 4 4 5 2 4v6l11-8 6-4 8 1v1l-9 1-5 6-10 7-3 1-1-1-1-8-5-7-5-4-10-3-6-2-27-3h-35l1-5 2-3z",
    fill: "#DA0C3C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,455)",
    d: "m0 0h16l5 4 4 6 6 4 7 2 1 2-11-2-6-4-3-5-3-2h-13l-7 2-2 4-5 5-10 2-2 4v10h-2v6l4 2 4 5 1 2v12l-2 1-2-15-6-6v-18l2-4 13-5 8-10z",
    fill: "#F74D5B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,641)",
    d: "m0 0h24l28 4 11 4 5 4 3 7v9l-3 7-7 6-1 2 4-1v2l-4 3h-3v2l-4 3-3-1 3-3-13 8-5 2v-2l13-8 12-9 6-5 3-10-4-12-8-4-12-3-19-2h-42v-2z",
    fill: "#E7E6E6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,406)",
    d: "m0 0h14l8 1 3 2 10 4 8 6 4 5 3 5 1 4 3 5 1 4 1 34-1 14h-1l-2-47-5-13v-2h-2l-3-6-15-9-11-3-26-1v-2z",
    fill: "#E5003B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1019,204)",
    d: "m0 0 3 3v8l-5 20-1 9v10l1 4 2-1-2 5-3 5h-2l-2-13 1-16 5-21 1-9v-3z",
    fill: "#BD4F56"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1640,199)",
    d: "m0 0h25v1l-27 2 4 1-11 4-10 6-12 9-11 9h-2l-1-7 4-2 10-8 13-8 14-6z",
    fill: "#BD4750"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,654)",
    d: "m0 0 2 2-1 7-2 7v29l-4-1-19-5-16-3 2-4 5-2-2 4 28 6v-22h2l1-10z",
    fill: "#DD0038"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(66,413)",
    d: "m0 0 2 2-1 7-1 3v5l-1 2v8l-3 13-1 13v8l-1 4v12l1 4v14l4 27 1 7h-2l-5-30-1-18v-21l1-20 5-32z",
    fill: "#E7E6E6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(977,654)",
    d: "m0 0h13l6 3 3 3 2 12 1 16v86l-5 3-2-1 3-2 1-4v-93l-1-12-3-6-6-3-12-1z",
    fill: "#B7474F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,495)",
    d: "m0 0 2 1-5 5v11l5 2v9l3 1 1 3v19l-2 3h-3l1-4-3-16-2-7-1-4-4-3 2-13z",
    fill: "#E00E3E"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,616)",
    d: "m0 0h1l1 6 1 153 3 1-2 1-4-4z",
    fill: "#B7474F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1471,664)",
    d: "m0 0 6 2 1 1v107l-5 3-2-1 4-4 1-105-5-2z",
    fill: "#B7474F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1728,632)",
    d: "m0 0 4 2 2 5-9 30-2 3-3-1 1-12 4-15 1-2 1-9z",
    fill: "#0191FC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,726)",
    d: "m0 0 1 2-6 12-6 10h-2l-2 5-9 10-6 7-3-1 4-7 9-12 14-19z",
    fill: "#FA0142"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(192,748)",
    d: "m0 0 9 4 10 6 14 7 11 6 9 4 9 2 6 3 7 3 2 2-7-1-22-8-24-11-18-10-6-4z",
    fill: "#D91540"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,629)",
    d: "m0 0 4 2 20 15 18 11 17 10-2 1h-5v-2l-6-1-19-12-9-6v-2l-4-1-3-3-4-2-7-9z",
    fill: "#D11A40"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,552)",
    d: "m0 0 5 1 4 5 2 24v11l-1 9-1 10-5 12h-2l3-11 3-19v-13l-2-19-2-4-3-1-8 22-2-1 2-7 2-5 3-11z",
    fill: "#E7E6E6"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(175,225)",
    d: "m0 0h16l4 1 1 4v12l-4 10-1-4 1-5-2-4v-3l-5-2 2-1-1-4 1-2-12 1-8 6-7 4-4 2 4-5 12-9z",
    fill: "#D6133E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,644)",
    d: "m0 0 2 1v20l-7 12-2 1 1-5 2-3 1-9-4-10-3-2h-7l-6 1 3-4z",
    fill: "#DB083B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1441,621)",
    d: "m0 0 2 2v38l-3 2h-4l1-14 1-21z",
    fill: "#0092FD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,444)",
    d: "m0 0 3 1 1 3v11l-1 3h2v5l3 9-1 3-3-4-3-14-2 3-1 14-3 5-2 8-2 2-1-2 4-13 2-16 1-5 1-9 1-2z",
    fill: "#E7E6E6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1591,625)",
    d: "m0 0v3l-11 12-3 5-3 3-2 6-5 9h-2l-1 5-5 17-1 10v24l3 17 1 7-2-3-3-12-1-7v-31l4-17 5-13 8-15 8-10 8-9z",
    fill: "#B7474F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(631,461)",
    d: "m0 0h6l-5 4-8 12-14 4-3 1-1-6 4-3 7-2 4-3h2v-2h2v-2z",
    fill: "#FA0143"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,459)",
    d: "m0 0h13l4 3 4 6 7 3 8 2 2 4v16h-3l-1-13-2-4-5-2-8-4-5-5-4-3h-9l-6 2v2h-2v2l-5 2 1-4 7-6z",
    fill: "#DE0038"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,631)",
    d: "m0 0 1 2-7 8-2 1-4 8-4 5-6 5-3 5h-2v2l-5 5-3 2h-8l-7-3 3-1h11l7-7 7-8 10-11 9-12z",
    fill: "#CF1840"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,475)",
    d: "m0 0 6 4 9 1 3 2-1 4-8 8 1 16-3 1-8-4h-8l-9 5h-2l-1-3 1-6h2v6l8-5h12l5 1v-5l-1-5 7-9-3-4-7-1-3-3z",
    fill: "#E7E6E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1535,201)",
    d: "m0 0h6l-2 2-13 4-12 9-9 7-8 6-3-1 3-7 4-2 11-8 16-8z",
    fill: "#BC4A51"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,420)",
    d: "m0 0h1l3 26 5 23 7 22v3h-2l-12-36-2-13-1-2v-13z",
    fill: "#D12243"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,555)",
    d: "m0 0 2 2-11 12-7 8-9 10-6 7h-2l-2 4-9 9-9 6-2 1h-7l-3-3 8 1 5-1v-2l6-5h2v-2h2l1-3h2v-2l3-3h2l2-4 4-4h2v-2h2l2-4 15-16z",
    fill: "#E7E6E6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(314,680)",
    d: "m0 0 9 1 5 2h10v2l-9 4-3 2-10-1-7-5v-2z",
    fill: "#FCFCFC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(864,654)",
    d: "m0 0h14l7 2 4 5 1 5v109l-5 3-2-1 5-5v-102l-2-9-2-3-7-2-13-1z",
    fill: "#B7474F"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,592)",
    d: "m0 0 2 1-3 14-6 15-7 9-2 1 1-5 10-24 4-10z",
    fill: "#B7474F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(63,580)",
    d: "m0 0 3 3 3 7 4 11v3l2 1 4 11 5 10 2 8-2 1-11-24-9-24z",
    fill: "#DA1540"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1463,376)",
    d: "m0 0 4 4 3 4 6 9 8 7 5 6v2l-4-1-10-8-8-10-4-7z",
    fill: "#EF1748"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,470)",
    d: "m0 0 2 1-3 2-9 3 1 6-1 9 4 6v2h2l2 5-1 13 2 3h-6v-5l1-1v-12l-4-6-4-3v-6h2l-1-12 3-3z",
    fill: "#DF0039"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,760)",
    d: "m0 0 5 1 8 4 9 3 7 2 1 2 13 2 9 3 12 2 4 2 4 1 1 2-11-2-22-5-33-12-7-3z",
    fill: "#E7E6E6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,305)",
    d: "m0 0v3l-9 12-8 14-8 20-2 6h-2v2h-2l3-12 6-13 6-11 7-11z",
    fill: "#EA6461"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(955,658)",
    d: "m0 0 4 1-8 2 1 108 1 5 6 4-2 2-1-3-5-2-1-2-1-113z",
    fill: "#B8474F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,614)",
    d: "m0 0h1l-1 11-4 8 13-1h22l27 3 5 1v1l-22-1-9-1h-34l-3-1 1-7 1-2 1-9z",
    fill: "#DD0038"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058,650)",
    d: "m0 0 2 3 2 15 1 101 1 5 3 3-5-1-1-1-1-104z",
    fill: "#B7474F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,800)",
    d: "m0 0h1l2 10 1 10 1 26 2 9v4h-2l-4-13z",
    fill: "#D31B41"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,619)",
    d: "m0 0h1v7l-1 4 38 1 18 2 18 4 2 2-13-2-21-3-11-1h-35l1-5 2-3z",
    fill: "#B8474F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,339)",
    d: "m0 0 2 2-6 9-9 11-9 10-13 13-1-3 10-10 7-8 6-7z",
    fill: "#F76462"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1652,598)",
    d: "m0 0h32l14 3 16 7 3 3-2 1-2-1v-2l-6-2-11-3v-2l-16-2h-24l-19 3-13 4-3-1 15-5z",
    fill: "#BB4950"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,654)",
    d: "m0 0 2 1-2 5-9 13-12 14-4 3 1-4 14-16 2-3v-5l-4 1 4-4z",
    fill: "#EAE9E9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,466)",
    d: "m0 0 3 1-4 4-10 2-2 4v10h-2v6l4 2 4 5 1 2v12l-2 1-2-15-6-6v-18l2-4 13-5z",
    fill: "#E4565B"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1112,253)",
    d: "m0 0 2 1-6 10-4 3h-2l-1 2h-2l-2 5v3l-4 3-2 2-6 7-3 3-2-1 10-13 8-10z",
    fill: "#B7474F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1445,755)",
    d: "m0 0h4v11l-5 12-2 3h-2l-1-4 4-13z",
    fill: "#0191FC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,588)",
    d: "m0 0h5l1 3h-4l-2 7-6 5-4 2-3 13-3 14v7l4 3-2 1-5-3 1-10 3-18 3-9 4-3 4-2 3-4z",
    fill: "#E7E6E6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,774)",
    d: "m0 0h2l-2 4-8 11-21 21-11 7-2-1 13-10h2l2-4 18-18z",
    fill: "#E7E6E6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,727)",
    d: "m0 0 2 4 8 27 7 17v2h-2l-10-20-2-7-3-17z",
    fill: "#D61840"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1709,514)",
    d: "m0 0h2v2l5 1 8 9 5 5 7 6h-3l-11-7-10-9-3-4z",
    fill: "#E61D49"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1526,514)",
    d: "m0 0h1l1 9 1 1v14l-2 5-3-1-1-2v-11z",
    fill: "#0191FC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1454,283)",
    d: "m0 0 3 2-12 17-7 10h-2l1-5 10-16 4-6z",
    fill: "#EB6464"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(182,235)",
    d: "m0 0h4l-2 6-8 13-3 3 2-6-1-5h-3-3l12-10z",
    fill: "#E7E6E6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(398,672)",
    d: "m0 0h1l1 16 2 6v4l-16-4-21-4 2-4 5-2-2 4 28 6z",
    fill: "#C24D52"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,480)",
    d: "m0 0 3 2 1 6-3 7h-7l-1-4 3-7z",
    fill: "#FA0143"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,517)",
    d: "m0 0 1 3 16-1 4 1-1 4-2 1-20 2 3-3 3-1-4-1z",
    fill: "#B9484F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1070,347)",
    d: "m0 0 3 1-4 2v12l1 3h8l10-4 7-4 2 1-9 6-13 5h-7l-2-6v-14z",
    fill: "#B7474F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1140,317)",
    d: "m0 0h7l6 4 10 9 3 1v5h-3l-8-8-7-6v-3h-9z",
    fill: "#BA4B52"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,246)",
    d: "m0 0 2 1-8 8-3 5-6 7-5 5-10 9v-3l9-10 7-8z",
    fill: "#CF1D41"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,600)",
    d: "m0 0h27l13 4 12 7v3l-4-2v-2l-10-3-2-1v-2l-11-2h-23l-16 3-4-1z",
    fill: "#B7474F"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,786)",
    d: "m0 0 4 1 2 2v9l-4 5h-9v-2l7-4z",
    fill: "#0190FB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,747)",
    d: "m0 0 4 2 3 7-4 6-6 3h-13l-16-4-12-5-1-2 9 3 16 5 14 1 8-3 1-2v-6z",
    fill: "#B7474F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1591,625)",
    d: "m0 0v3l-11 12-3 5-3 3-2 6-5 9-3-1 9-17 8-10 8-9z",
    fill: "#D04D55"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,590)",
    d: "m0 0 16 8 15 9 2 4-5-2-24-13-5-5z",
    fill: "#E8E7E7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,552)",
    d: "m0 0 5 1 4 5-1 5-6-6-2 2-7 20-2-1 2-7 2-5 3-11z",
    fill: "#E8E7E7"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,678)",
    d: "m0 0m-1 1m-1 1 1 2-1 2 4-1v2l-4 3h-3v2l-4 3-3-1 3-3-13 8-5 2v-2l13-8z",
    fill: "#E8DDDD"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,585)",
    d: "m0 0 3 1-1 10-5 19-5 10h-3l5-10 5-15 1-7-3 4-2 2 2-9z",
    fill: "#DD0038"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,797)",
    d: "m0 0h44l-3 5-9 8v-3l8-7-40-2z",
    fill: "#B9484F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,786)",
    d: "m0 0 4 1 2 5-1 7-5 4h-7l7-7-1-9z",
    fill: "#0290FB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,407)",
    d: "m0 0 10 1 13 8 3 3 2 7-2 2-5-8-9-7-9-3-5-1z",
    fill: "#C74E54"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,842)",
    d: "m0 0 4 4 6 8 5 16 1 8-3-4-4-10-4-11-5-9z",
    fill: "#D8153F"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,664)",
    d: "m0 0 6 1 1 1v84h-1l-1-82z",
    fill: "#B7474F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,320)",
    d: "m0 0h2l-2 10-6 25-1 6h-1l-1-5v-8l4-11z",
    fill: "#D31E42"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,115)",
    d: "m0 0 4 1 9 9 10 13 4 6-1 4-12-17-14-15z",
    fill: "#E15F5E"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,334)",
    d: "m0 0 1 4-2 12-1 20-2-2-1-3v-10l1-9 2-10h2z",
    fill: "#FA0143"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,631)",
    d: "m0 0 1 2-7 8-2 1-2 5-8 7-9 9v-3l8-8 9-11 7-9z",
    fill: "#D41740"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,728)",
    d: "m0 0h2v10l-9 7-16 9-8 4-3-1 19-10 11-7h2z",
    fill: "#E7E6E6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,645)",
    d: "m0 0 1 3-7 14-2 10h-1v-10l2-6-8 9v-3l14-16z",
    fill: "#B7474F"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,817)",
    d: "m0 0 2 1-9 6-16 9-12 11-2-2 1-2h2l1-3 15-10 17-9z",
    fill: "#E7E6E6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1165,754)",
    d: "m0 0 5 2 9 4 16 2 16-2-3 2-8 2h-16l-16-5z",
    fill: "#B7474F"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,564)",
    d: "m0 0 2 1-4 5-8 7-4 1-4-5-4-2-3-4 1-2 9 8 5-1z",
    fill: "#CC2745"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,772)",
    d: "m0 0 8 3 9 2 6 3 7 3 2 2-7-1-22-8-3-2z",
    fill: "#E10F3F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,472)",
    d: "m0 0 7 1 2 4v16h-3l-1-13-2-4-3-2z",
    fill: "#E5003B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(760,384)",
    d: "m0 0 1 4-7 7-11 7v-3l6-5 1-2h2l1-3z",
    fill: "#FA0143"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1626,204)",
    d: "m0 0h5l-1 2-12 6-13 9-2-1 5-5 10-7z",
    fill: "#DF5C5C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,706)",
    d: "m0 0 1 3-1 5 2 11 1 9 3 9 1 4-3-3-4-11-2-11v-13z",
    fill: "#E7E6E6"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(398,594)",
    d: "m0 0 2 2-2 5-1 5-3 9-4 8-2 3h-2l-1 4h-2l2-5 6-10z",
    fill: "#E7E6E6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,480)",
    d: "m0 0h7l-4 2-2 4 5 6 1 7-2 3-2-9-7-8 1-4z",
    fill: "#E9E8E8"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,732)",
    d: "m0 0h2l-2 4-10 14-7 9-3 3 1-4 13-18 4-6z",
    fill: "#E7E6E6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,420)",
    d: "m0 0h1l2 19v13l-2-3-2-6v-13z",
    fill: "#D31A41"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1363,367)",
    d: "m0 0 3 3 2 10 1 3h2l7 15-3-1-6-9-5-13z",
    fill: "#B7474F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1365,334)",
    d: "m0 0h1v10l-1 2-1 9v12h-2l-1-5v-10l3-17z",
    fill: "#BA4850"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(602,529)",
    d: "m0 0 2 1-25 25-5 1 5-5 16-15z",
    fill: "#CB2845"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,511)",
    d: "m0 0 3 1-4 5h-13l-14-1 1-2h20z",
    fill: "#E11140"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1535,201)",
    d: "m0 0h6l-2 2-13 4-2 2-6 2-5 3h-2l1-3 16-8z",
    fill: "#D05457"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,644)",
    d: "m0 0 8 1v1l-9 1-5 6-5 1-4 4h-4v-10l2 2v6l11-8z",
    fill: "#BF3D4C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(50,525)",
    d: "m0 0 4 3 2 12v7l-2 3-4-20z",
    fill: "#D61840"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,686)",
    d: "m0 0 2 1-2 3 16 2 12 3v1h-10l-1-1-11-1v-2l-8-1 1-4z",
    fill: "#DD0038"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,666)",
    d: "m0 0h2l-2 4-11 14-7 6 1-4 14-16z",
    fill: "#E7E6E6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,618)",
    d: "m0 0 2 1-7 8-5 2-2 4-8 8v-3l7-8 8-8z",
    fill: "#DE3A44"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1462,356)",
    d: "m0 0h1v24l-2-2-2-6v-9l1-4h2z",
    fill: "#DB4D56"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1372,647)",
    d: "m0 0 4 1-5 3v5l-1 1 5 5-2 1-8-6v-5l5-4z",
    fill: "#BF4B51"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(905,339)",
    d: "m0 0 1 2-7 19h-2v2h-2l3-12 5-9z",
    fill: "#EA605F"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,612)",
    d: "m0 0h2l7 14 2 8-2 1-9-20z",
    fill: "#D81A41"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1022,606)",
    d: "m0 0 6 2 10 8 7 7 1 3-4-2-10-10-10-6z",
    fill: "#D35558"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,557)",
    d: "m0 0 5 5 7 9 9 8 6 4-3 1-11-9-8-8-5-8z",
    fill: "#E7E6E6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,644)",
    d: "m0 0 1 3-14 16-7 7v-3l7-8 11-12z",
    fill: "#E7E6E6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,529)",
    d: "m0 0m-1 1m-1 1m-1 1m-13 1h8l4 2h-9l-9 4-10 9-2-1 8-8 7-5z",
    fill: "#E7E6E6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,226)",
    d: "m0 0h15v1l-12 1-8 6-7 4-4 2 4-5z",
    fill: "#CE1E41"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1540,788)",
    d: "m0 0 3 1 1 7-3 6h-6l3-5 1-1z",
    fill: "#0290FA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,499)",
    d: "m0 0h3l2 5-1 13 2 3h-6v-5l1-1v-12z",
    fill: "#DF0038"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,614)",
    d: "m0 0v3l-7 7-4 6h-2l-3 9-2 2 1-6 6-10 9-10z",
    fill: "#CA4D54"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,763)",
    d: "m0 0h2l-2 4-8 11-4 4-5 1h-10v-1l12-2 7-5 3-5z",
    fill: "#E7E6E6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,526)",
    d: "m0 0m-4 1h4v2l-10 8-4 5-7 6-2-1 17-17z",
    fill: "#DB0238"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(124,671)",
    d: "m0 0 7 6 6 7 5 5 6 7-1 2-7-7-7-8-9-10z",
    fill: "#E7E6E6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,320)",
    d: "m0 0 1 3 2-1-2 12-1 2h-2l-1-7z",
    fill: "#BF4750"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1299,763)",
    d: "m0 0 4 1 2 7v14l-3 3 1-16-4-6z",
    fill: "#FA0143"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,514)",
    d: "m0 0m-2 1 23 2v1h-21l-4 4-1-4z",
    fill: "#D93D4F"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,495)",
    d: "m0 0 2 1-5 5v11l5 2v2l-7-1-1-1v-12z",
    fill: "#BD4A51"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1153,287)",
    d: "m0 0h2l-1 4-13 16-5 4-2-1 11-11 2-4 5-5z",
    fill: "#C1404F"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1433,178)",
    d: "m0 0 2 1-7 9-6 10-2-1 7-13 4-5zm-14 20 2 2-2 2z",
    fill: "#E76463"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,494)",
    d: "m0 0 4 2 4 6v12l-2 1-2-15-4-4z",
    fill: "#C94A53"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,681)",
    d: "m0 0 5 1 3 1h10v2l-11 3-4-2-1-3z",
    fill: "#E7E6E6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1812,400)",
    d: "m0 0 10 5 1 2h-7l-8-4v-2z",
    fill: "#F41C4C"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,684)",
    d: "m0 0 2 1-2 3 16 4v1l-10-1-11-2 2-4z",
    fill: "#B7474F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,503)",
    d: "m0 0h2v6l8-5 8 1v1l-9 2-7 4h-2l-1-3z",
    fill: "#E7E6E6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,461)",
    d: "m0 0h2l5 6 11 4 1 2-11-2-6-4-3-5z",
    fill: "#C04C52"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,883)",
    d: "m0 0h17l-2 2-8 1h-11l-5-1v-1z",
    fill: "#E12145"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,378)",
    d: "m0 0 3 3 4 9 3 5v2h-3l-6-11z",
    fill: "#F5294F"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1460,274)",
    d: "m0 0 3 1-3 6-2 3h-5l2-4 3-5z",
    fill: "#F55956"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(274,786)",
    d: "m0 0 9 1 15 3 1 2-10-1-15-4z",
    fill: "#E10F3F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1745,750)",
    d: "m0 0h3l1 6-3 4-3-1 1-8z",
    fill: "#0191FB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,749)",
    d: "m0 0 4 1 1 9-5-5-4 3-2-1z",
    fill: "#C72845"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,606)",
    d: "m0 0 4 2v2l-5-1v2l-6 3-1 5h-1l-1-7z",
    fill: "#CA2946"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,421)",
    d: "m0 0 3 3 5 16v2h-2l-2-6-2-3-1-7z",
    fill: "#E95A5D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(804,339)",
    d: "m0 0 2 2-6 9-4 4-1-3z",
    fill: "#E65F5E"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,523)",
    d: "m0 0 1 2-3 5 11 7-2 1-5-3-7-3 1-5z",
    fill: "#BA4850"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,689)",
    d: "m0 0 2 2-17 17-3 1 2-4 10-9z",
    fill: "#E7E6E6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,688)",
    d: "m0 0 3 1 3 9 5 4v2l-4-1-4-5-3-7z",
    fill: "#E8E7E7"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,320)",
    d: "m0 0h2l-2 10-3 11-2-4z",
    fill: "#CF2042"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,645)",
    d: "m0 0h3v2l-8 7-9 9v-3l8-8z",
    fill: "#CD2C47"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1591,625)",
    d: "m0 0v3l-11 12-2-2 11-12z",
    fill: "#D25257"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,749)",
    d: "m0 0 2 1v2h-2l-2 4-5 4-2-2z",
    fill: "#E8E7E7"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1786,383)",
    d: "m0 0 7 6 9 8-1 2-11-9-4-5z",
    fill: "#F33352"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1165,754)",
    d: "m0 0 5 2 9 4 5 2-4 1-12-4z",
    fill: "#C14C52"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(906,603)",
    d: "m0 0 10 4 7 5-2 2-3-2v-2l-10-3-2-1z",
    fill: "#CD5256"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,457)",
    d: "m0 0 18 1 3 3-4-1h-13l-7 2z",
    fill: "#B7474F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(602,867)",
    d: "m0 0 2 2v5l-4 2-10-1v-1l11-1z",
    fill: "#E8E7E7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,685)",
    d: "m0 0m-1 1m-1 1m-2 1h2l-2 4-12 7h-2v-2l13-8z",
    fill: "#E7E6E6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1236,334)",
    d: "m0 0 1 4v3l2-1-2 5-5 5 1-7z",
    fill: "#B7474F"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,133)",
    d: "m0 0 4 1 7 10-1 4-10-14z",
    fill: "#E7605E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,605)",
    d: "m0 0 4 2 2 2 7-1 5-1-4 3-5 2-5-1-4-5z",
    fill: "#C04C52"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(192,555)",
    d: "m0 0 4 5 6 8v2l-4-2-7-11z",
    fill: "#CE1B40"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,663)",
    d: "m0 0 1 3-11 11-1-2 4-5h2v-2h2l2-4z",
    fill: "#D52244"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,635)",
    d: "m0 0 2 1-7 8-7 6v-3l3-1v-2l7-6z",
    fill: "#E7E6E6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(544,492)",
    d: "m0 0 1 2-4 9-2 7-2-3 4-11z",
    fill: "#DE083B"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,327)",
    d: "m0 0 1 3-4 9-3 1 1-6z",
    fill: "#ED6361"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,650)",
    d: "m0 0m-1 1m-1 1v3l-9 6-2-1v-7h1v5l5-2z",
    fill: "#DD0038"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1103,618)",
    d: "m0 0 2 1-7 8-4 2v-3z",
    fill: "#D05457"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(415,525)",
    d: "m0 0h2v9l-2 3-2-4 1-7z",
    fill: "#E9E9E9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,470)",
    d: "m0 0 2 1-3 2-12 4 2-4 1-1z",
    fill: "#E3003A"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1370,383)",
    d: "m0 0 3 4 5 11-3-1-4-6z",
    fill: "#EB1D4C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768,94)",
    d: "m0 0 5 2 9 6-2 2-12-8z",
    fill: "#FA0143"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,491)",
    d: "m0 0 1 3-4 8h-2l1-6z",
    fill: "#E8E7E7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,466)",
    d: "m0 0 3 1-4 4-9 1 1-2 8-3z",
    fill: "#B7474F"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1476,625)",
    d: "m0 0 1 2-8 7-3 3h-2l2-4z",
    fill: "#CE3F44"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,615)",
    d: "m0 0 4 2 7 8h-3l-8-8z",
    fill: "#DF4053"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,466)",
    d: "m0 0h3l2 7-3-3-3 1-4 4 2-5z",
    fill: "#E8E7E7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1626,204)",
    d: "m0 0h5l-1 2-10 5-2-1 4-4z",
    fill: "#E7595C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1266,377)",
    d: "m0 0h2v7l-1-4-8 7-2 1 2-4z",
    fill: "#B7474F"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,352)",
    d: "m0 0 1 3-5 5v-4z",
    fill: "#F06561"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1365,334)",
    d: "m0 0h1v10l-1 2h-2l1-11z",
    fill: "#B7474F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1578,639)",
    d: "m0 0 1 3-5 6-2 4-1-3 6-9z",
    fill: "#CA4D54"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(157,482)",
    d: "m0 0h3l3 9v3h-2z",
    fill: "#D32344"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1234,759)",
    d: "m0 0h5l-1 3-6 2-2-1v-2z",
    fill: "#0290FB"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,456)",
    d: "m0 0 1 2-5 8-3-1 6-8z",
    fill: "#EF505B"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1154,362)",
    d: "m0 0v3l-7 8-3 2 2-4 4-5h2z",
    fill: "#BE4B51"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1010,198)",
    d: "m0 0 9 5v2h-2l-1 2-6-7z",
    fill: "#F70343"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7252fa31e2a5e6d546d18c049fe9efa9.svg";
export { ForwardRef as ReactComponent };